import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="zoom"
export default class extends Controller {
  static targets = ["zoomable", "value", "actionUrl"];

  connect() {
    const query = new URLSearchParams(window.location.search);
    this.value = parseInt(query.get("zoom") || "100");
    this.#zoom();
  }

  increment() {
    this.value += 1;
    this.#zoomAndUpdateUrls();
  }

  decrement() {
    if (this.value <= 1) return;

    this.value -= 1;
    this.#zoomAndUpdateUrls();
  }

  set() {
    this.value = parseInt(this.valueTarget.value);
    if (this.value <= 1) return;

    this.#zoomAndUpdateUrls();
  }

  #zoomAndUpdateUrls() {
    this.#zoom();
    this.#updateUrl();
    this.#updateActionUrls();
  }

  #zoom() {
    this.valueTarget.value = this.value;
    this.zoomableTargets.forEach(
      (target) => (target.style.zoom = `${this.value}%`),
    );
  }

  #updateUrl() {
    const query = new URLSearchParams(window.location.search);
    query.set("zoom", this.value);

    const queryParams = query.toString();

    const url = `${window.location.pathname}${
      queryParams === "" ? "" : `?${queryParams}`
    }`;

    history.replaceState(null, "", url);
  }

  #updateActionUrls() {
    this.actionUrlTargets.forEach((el) => {
      const ref = el[el.dataset.urlRef];

      if (ref) {
        const url = new URL(ref);
        const query = new URLSearchParams(url.search);
        query.set("zoom", this.value);
        const queryParams = query.toString();

        const newUrl = `${url.pathname}${
          queryParams === "" ? "" : `?${queryParams}`
        }`;

        el[el.dataset.urlRef] = newUrl;
      }
    });
  }
}
